import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

import Calculate from '../utils/calculator'


const initialState = {

  dieselConsumptionJaw: {
    value: 25,
    unit: 'l/h',
    min: 0,
    precision:1,
    label: "Backenbrecher",
  },
  eConsumptionJaw: {
    value: 0,
    unit: 'kWh',
    min: 0,
    precision:1,
    label: "Backenbrecher",
    component: "Result"
  },
  dieselConsumptionCone: {
    value: 45,
    unit: 'l/h',
    min: 0,
    precision:1,
    label: "Kegelbrecher",
  },
  eConsumptionCone: {
    value: 0,
    unit: 'kWh',
    min: 0,
    precision:1,
    label: "Kegelbrecher",
    component: "Result"
  },
  dieselConsumptionScreen: {
    value: 10,
    unit: 'l/h',
    min: 0,
    precision:1,
    label: "Screen",
  },
  eConsumptionScreen: {
    value: 0,
    unit: 'kWh',
    min: 0,
    precision:1,
    label: "Screen",
    component: "Result"
  },
  dieselConsumptionTotal: {
    value: 0,
    unit: 'l/h',
    min: 0,
    precision:1,
    label: "Total",
    component: "Result"
  },
  eConsumptionTotal: {
    value: 0,
    unit: 'kWh',
    min: 0,
    precision:1,
    label: "Total",
    component: "Result"
  },

  dieselPrice: {
    value: 1.8,
    unit: '€/l',
    min: 0,
    precision:3,
    step:0.1,
    label: "Preis",
  },
  ePrice: {
    value: 0.22,
    unit: '€/kWh',
    min: 0,
    precision:4,
    step:0.1,
    label: "Preis",
  },

  dieselCostPerHour: {
    value: 0,
    unit: '€/h',
    min: 0,
    precision:3,
    label: "Kosten pro Stunde",
    component: "Result",
  },
  eCostPerHour: {
    value: 0,
    unit: '€/h',
    min: 0,
    precision:3,
    label: "Kosten pro Stunde",
    component: "Result",
  },
  dieselCostPerYear: {
    value: 0,
    unit: '€/a',
    min: 0,
    precision:0,
    label: "Cost per year",
    component: "Result",
  },
  eCostPerYear: {
    value: 0,
    unit: '€/a',
    min: 0,
    precision:0,
    label: "Cost per year",
    component: "Result",
  },

  savingsTotal: {
    value: 0,
    precision: 0,
    unit:'€/JAHR',
    label: "Savings",
    component: "Result",
  },
  savingsTotalPercentage: {
    value: 0,
    precision: 0,
    unit:'%',
    label: "Savings percentage",
    component: "Result",
  },
  savingsCO2Total: {
    value: 0,
    precision: 0,
    unit:'kg/JAHR',
    label: "Savings",
    component: "Result",
  },

  weeklyHours: {
    value: 40,
    min: 1,
    max: 168,
    step:1,
    precision: 0,
    unit:"Stunden",
    label: "Wöchentliche Stunden"
  },
  yearlyHours: {
    value: 0,
    precision: 0,
    unit:"Stunden",
    label: "Jährliche Stunden",
    component: "Result",
  },

  capacity: {
    value: 300,
    precision: 0,
    unit:'tph',
    label: "Leistung",
  },
  capacityPerYear: {
    value: 0,
    precision: 0,
    unit:'Tonnen/a',
    label: "Jährliche Kapazität",
    component: "Result",
  },
  dieselCostPerTon: {
    value: 0,
    precision: 2,
    unit:'€/tonnes',
    label: "Cost per ton",
    component: "Result",
  },
  eCostPerTon: {
    value: 0,
    precision: 2,
    unit:'€/tonnes',
    label: "Cost per ton",
    component: "Result",
  },

  dieselCO2Emission: {
    value: 2.97,
    precision: 2,
    unit:'kg/l',
    label: "Diesel CO2 emission",
    component: "Result",
  },
  eCO2Emission: {
    value: 0.5296,
    precision: 4,
    unit:'kg/kWh',
    label: "Electricity CO2 emission",
    component: "Result",
  },

  dieselCO2Jaw: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Jaw",
    component: "Result",
  },
  eCO2Jaw: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Jaw",
    component: "Result",
  },
  dieselCO2Cone: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Cone",
    component: "Result",
  },
  eCO2Cone: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Cone",
    component: "Result",
  },
  dieselCO2Screen: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Screen",
    component: "Result",
  },
  eCO2Screen: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Screen",
    component: "Result",
  },
  dieselCO2Total: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Total",
    component: "Result",
  },
  eCO2Total: {
    value: 0,
    precision: 0,
    unit:'kg/h',
    label: "Total",
    component: "Result",
  },

};

export const calcSlice = createSlice({
  name: 'calc',
  initialState,
  reducers: {
    setValue: (state, action: PayloadAction<{ name: string, value: any }>) => {
      // @ts-ignore
      state[action.payload.name].value = action.payload.value

      return Calculate(state,action.payload.name)

    },
    runCalculations: (state) => {
      // @ts-ignore

      return Calculate(state,null)

    },
/*     setCountries: (state, action: PayloadAction<{ countries: any }>) => {
      state.co2factors = action.payload.countries
      const countryList = action.payload.countries.map( (item:any, index:number) => {
        return {value:item.country, label:item.country, key:index}
      })
      state.location.options = countryList
      return Calculate(state,'location')
    },
    setEnergyConsumptions: (state, action: PayloadAction<{ energyConsumptions: any }>) => {
      state.energyConsumptions = action.payload.energyConsumptions
      const metalList = action.payload.energyConsumptions.map( (item:any, index:number) => {
        return {value:item.metal, label:item.metal, key:index}
      })
      state.material.options = metalList
      return Calculate(state,'material')
    },
    setCellSizes: (state, action: PayloadAction<{ cellSizes: any }>) => {
      state.cellSizes = action.payload.cellSizes
      const cellList = action.payload.cellSizes.map( (item:any, index:number) => {
        return {value:item.volume.toString(), label:item.name, key:index}
      })
      state.cellSize.options = cellList
      return Calculate(state,'cellSize')
    }, */
  },
});

export const calcActions = calcSlice.actions;

export const selectProperty = (property: string) => (state: RootState) => {
  if (state.calc.hasOwnProperty(property)) {
    // @ts-ignore
    return state.calc[property]
  }
  return undefined
}
/* 
export const getLocationStatus = () => (state: RootState) => {
  if(state.calc.location.value) {
    return true
  }
  return false
}

export const getProcessStatus = () => (state: RootState) => {
  if(state.calc.material.value && state.calc.throughput.value && state.calc.headGrade.value && state.calc.recovery.value) {
    return true
  }
  return false
}

export const getOperationStatus = () => (state: RootState) => {
  if(state.calc.cellSize.value !=='0' && state.calc.cellsPerLine.value && state.calc.linesParallel.value) {
    return true
  }
  return false
}

export const getUtilizationStatus = () => (state: RootState) => {
  if(state.calc.availability.value) {
    return true
  }
  return false
}

export const getCostsStatus = () => (state: RootState) => {
  if(state.calc.materialPrize.value && state.calc.treatmentCharges.value && state.calc.concentratorPower.value && state.calc.energyCost.value) {
    return true
  }
  return false
}

export const getValueStatus = () => (state: RootState) => {
  if(state.calc.expectedShift.value) {
    return true
  }
  return false
}

export const getPdfStatus = () => (state: RootState) => {
  if(
    state.calc.location.value &&
    state.calc.material.value && state.calc.throughput.value && state.calc.headGrade.value && state.calc.recovery.value && 
    state.calc.cellSize.value !=='0' && state.calc.cellsPerLine.value && state.calc.linesParallel.value && 
    state.calc.availability.value &&
    state.calc.materialPrize.value && state.calc.treatmentCharges.value && state.calc.concentratorPower.value && state.calc.energyCost.value &&
    state.calc.expectedShift.value
    ) {
    return false
  }
  return true
}
 */

export const getEqualValues = () => (state: RootState):{[key:string]:number} => {
  if(state.calc.dieselCO2Total.value > 0 && state.calc.eCO2Total.value) {
    const co2Value = state.calc.dieselCO2Total.value - state.calc.eCO2Total.value 
    return {'cars':co2Value/4.75, 'trees':co2Value/0.039, 'planes':co2Value/0.231}
  }
  return  {'cars':0, 'trees':0, 'planes':0}
}

export const printCalculation = () => (state: RootState):any => {
  return state.calc
}

export const annualCostBar = () => (state: RootState):any => {

  return [
    {
      name:'Diesel',
      cost: state.calc.dieselCostPerYear.value
    },
    {
      name:'Elektrizität',
      cost: state.calc.eCostPerYear.value
    },

  ]

}

export const costPerTonBar = () => (state: RootState):any => {

  return [
    {
      name:'Diesel',
      cost: Math.round(state.calc.dieselCostPerTon.value*100)/100
    },
    {
      name:'Elektrizität',
      cost: Math.round(state.calc.eCostPerTon.value*100)/100
    },

  ]

}

export const co2EmissionBar = () => (state: RootState):any => {

  return [
    {
      name:'Diesel',
      cost: Math.round(state.calc.dieselCO2Total.value*100)/100,
    },
    {
      name:'Elektrizität',
      cost: Math.round(state.calc.eCO2Total.value*100)/100,
    },

  ]

}

export default calcSlice.reducer;